<div class="sub-header">
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb />
      </div>
    </div>

    <div class="row">
      <div class="col">
        @if (this.salesTeams$ | async; as salesTeams) {
          <div class="d-inline-block mx-2">
            <ng-select
              class="form-control form-control-sm"
              style="width: 235px;"
              bindValue="id"
              bindLabel="name"
              [items]="salesTeams"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="this.salesTeamIds"
              (ngModelChange)="this.onSalesTeamIdsChange()"
            >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }}
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length }">ATTENDANCE_LBL_SALESTEAM_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="salesteam-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ps-1" title="{{ item.name }}">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        }

        @if (this.groups$ | async; as groups) {
          <div class="d-inline-block mx-2">
            <ng-select
              class="form-control form-control-sm"
              style="width: 235px;"
              bindValue="id"
              bindLabel="name"
              [items]="groups"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="this.groupIds"
              (ngModelChange)="this.onGroupIdsChange()"
            >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }}
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length }">ATTENDANCE_LBL_GROUP_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="group-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ps-1" title="{{ item.name }}">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        }

        @if (this.users$ | async; as users) {
          <div class="d-inline-block mx-2">
            <ng-select
              class="form-control form-control-sm"
              style="width: 265px;"
              bindValue="id"
              bindLabel="name"
              [items]="users"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="this.userIds"
              (ngModelChange)="this.onUserIdsChange()"
            >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }}
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length }">ATTENDANCE_LBL_SALESPERSON_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="salesperson-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ps-1" title="{{ item.name }}">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        }

        <div class="form-check d-inline-block mx-2">
          <input
            id="includeFormerEmployees"
            class="form-check-input"
            type="checkbox"
            [(ngModel)]="this.includeFormerEmployees"
            (ngModelChange)="this.onPopulationChange()"
          />
          <label class="form-check-label" for="includeFormerEmployees">{{ 'ATTENDANCE_LBL_INCLUDE_FORMER_EMPLOYEES' | translate }}</label>
        </div>
      </div>

      <div class="col-auto">
        <div class="d-inline-block float-end mx-2 day-nav">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [title]="'ATTENDANCE_LBL_PREVIOUS_DAY' | translate"
            (click)="this.stepDay(-1)"
          >&lsaquo;</button>
          <input
            class="form-control form-control-sm d-inline-block mx-1"
            style="width: 165px;"
            type="date"
            [max]="this.maxDay"
            [ngModel]="this.day"
            (ngModelChange)="this.onDayChange($event)"
          />
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="!this.canStepForward"
            [title]="'ATTENDANCE_LBL_NEXT_DAY' | translate"
            (click)="this.stepDay(1)"
          >&rsaquo;</button>
        </div>
      </div>
    </div>
  </div>
</div>
